import React from 'react';
import { ReactComponent as Facebook } from '../../../Assets/facebook.svg';
import { ReactComponent as X } from '../../../Assets/X.svg';
import { ReactComponent as Insta } from '../../../Assets/insta.svg';
import { ReactComponent as Linkedin } from '../../../Assets/linkedin.svg';
import { ReactComponent as AppStore } from '../../../Assets/appStore.svg';
import { ReactComponent as GooglePlay } from '../../../Assets/googlePlay.svg';
import { ReactComponent as FooterLogo } from '../../../Assets/footerLogo.svg';
import './style.scss';
const Footer = () => {
  return (
    <div className="footer">
      <div className="contactUs">
        <div>
          <h2>Contact Us</h2>
          <p className="contact-us-address">
            Trendz JR,
            <br />
            Plot No: 23 &24 Survey No: 31 to 36, 2nd Floor,
            <br />
            Vittal Rao Nagar Rd
            <br />
            Gafoornagar, Madhapur,
            <br />
            Hyderabad, Telangana-500081
            <br />
          </p>
          <a
            href="mailto:info@studenttribe.in"
            style={{ textDecoration: 'none' }}
          >
            <p className="email">Email: info@studenttribe.in</p>
          </a>
        </div>
        <div className="follow-us-section">
          <h2>Follow us on:</h2>
          <div className="follow-us-links">
            <a
              href="https://www.linkedin.com/company/stumagz/"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <p>
                <Linkedin /> linkedin.com/stumagz
              </p>
            </a>
            <a
              href="https://www.youtube.com/@StudentTribe"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <p>
                <Facebook /> youtube.com/stumagz
              </p>
            </a>
            <a
              href="https://www.instagram.com/studenttribe.st/"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <p>
                <Insta /> instagram.com/stumagz
              </p>
            </a>
            <a
              href="https://x.com/Student_Tribe"
              target="_blank"
              rel="noreferrer"
              style={{ textDecoration: 'none' }}
            >
              <p>
                <X /> twitter.com/Stumagz
              </p>
            </a>
          </div>
        </div>
        <div className="footer-download-section">
          <h2>Download app</h2>
          <div className="downloadApp">
            <a
              href="https://apps.apple.com/us/app/student-tribe/id1362552730"
              target="_blank"
              rel="noreferrer"
            >
              <AppStore />
            </a>
            <a
              href="https://play.google.com/store/apps/details?id=com.tdevelopers.stumagz"
              target="_blank"
              rel="noreferrer"
            >
              <GooglePlay />
            </a>
          </div>
        </div>
        <div className="footer-title">
          <h1>Students Unite, Minds Ignite At StudentTribe</h1>
        </div>
      </div>
      <div className="copyright">
        <FooterLogo />
        <p>
          Copyright@Student Tribe (A unit of Colosseum CQ Solutions Pvt Ltd).
          All rights reserved.
        </p>
      </div>
    </div>
  );
};

export default Footer;
